/**
 * Gestione Sottoscrizioni
 *
 * Contact: bonjoprg@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateSubscriptionDto { 
    nomeCompleto: string;
    email: string;
    telefono: string;
    importo: number;
    modalitaPagamento: CreateSubscriptionDtoModalitaPagamentoEnum;
    intestatario?: string;
    iban?: string;
    rateizzazione?: string;
    firmaBase64: string;
}
export enum CreateSubscriptionDtoModalitaPagamentoEnum {
    Contanti = 'CONTANTI',
    Bonifico = 'BONIFICO',
    Pos = 'POS',
    Rid = 'RID'
};



